import Joi from '@hapi/joi'

export const ignoreSessionSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate Required`,
        "any.required": `Estate Required`
    }),
    collectionPointID:Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Division Required`,
        "any.required": `Division Required`
    }),
    fieldID:Joi.number().invalid(0).label("Field").messages({
        "any.invalid": `Field Required`,
        "any.required": `Field Required`
    }),
    isActive: Joi.boolean().label("Active"),
    registrationNumber:  Joi.string().required().label("Registration Number").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Registration Number required`,
        "string.pattern.base": `Please enter valid Registration Number`,
    }),
    reason:  Joi.string().required().label("Reason").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Reason required`,
        "string.pattern.base": `Please enter valid Reason`,
    }),
    searchDate:  Joi.string().required().label("Date").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Date code required`,
        "string.pattern.base": `Please enter valid Date`,
    }),
    rejectReason:  Joi.string().required().label("Reason").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Reason required`,
        "string.pattern.base": `Please enter valid Reason`,
    }),
    statusID:Joi.number().label("Status").messages({
        "any.invalid": `Status Required`,
        "any.required": `Status Required`
    }),
}














